<template>
  <vz-toolbar>
    <div class="text-h1 color-dark mb-30 mt-30">
      {{ title }}
    </div>
    <template-autocomplete
        v-if="showTemplateList"
        class="ml-auto mr-10"
        @select="selectTemplate"
    />
  </vz-toolbar>
</template>

<script setup lang="ts">
import VzToolbar from '~/components/ui-kit/vz-toolbar.vue';
import {useOrderStore} from "~/stores/order";
import {storeToRefs} from "pinia";
import {useUserStore} from "~/stores/personal/user";
import {TemplateOrder} from "~/types/order/orderV3";
import TemplateAutocomplete from "~/components/autocomplete/template-autocomplete.vue";

const orderStore = useOrderStore()
const { isAuth } = storeToRefs(useUserStore())
const route = useRoute()

const isNewOrder = computed(() => {
  return !route.params.guid
})

const title = computed(() => {
  return !isNewOrder.value ? 'Редактирование заказа' : 'Оформление заказа'
})

const isLightOrder = computed(() => {
  return route.name === 'order-light'
})

const isMultiOrder = computed(() => {
  return orderStore.orderType === 'multi'
})

const showTemplateList = computed(() => {
  if (isMultiOrder.value && orderStore.multiOrder.locked || isLightOrder.value) {
    return false
  }
  return isAuth.value && isNewOrder.value
})

async function selectTemplate(value: TemplateOrder) {
  orderStore.applyTemplate(value, true)
}
</script>

<style lang="scss">

</style>
